import { useChangelogApi } from '@entities/changelog'
import { useOnTimezoneChange } from '@entities/viewer'

/** The customer's changelog tab: the shared changelog table, pointed at the customer by the middleware. */
export const useCustomerChangelogPage = (): void => {
  onMounted(() => {
    void useChangelogApi()
  })

  useOnTimezoneChange(() => {
    void useChangelogApi()
  })
}
